import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Order from "../../pages/InventoryManagement/Order/Order";

const OrderRoutes = {
  path: "/inventory",
  element: <Navbar />,
  children: [
    {
      path: "orders",
      element: <Order />,
    },
  ],
};

export default OrderRoutes;
